import { useState, useEffect } from 'react'

import type { Seminar } from 'services/seminars/types'
import * as seminarsApi from 'services/seminars'
import cookies from 'services/cookies'
import errorLogging from 'services/error-logging'

const SEMINARS_ALL_QUERY = [
  'level-one',
  'online-level-one',
  'level-two',
  'level-four',
  'kids',
  'online-kids',
  'educators',
]

function sortByDates(a: Seminar, b: Seminar) {
  const dateA = new Date(a.startDate).getTime()
  const dateB = new Date(b.startDate).getTime()
  return dateA - dateB
}

type Params = {
  seminarType: string
  limit: number
}

function useSeminars({ seminarType, limit }: Params) {
  const [isLoading, setIsLoading] = useState(true)
  const [seminars, setSeminars] = useState<Seminar[]>([])

  useEffect(() => {
    async function fetch() {
      const token = cookies.getAccessToken()

      try {
        const results = await seminarsApi.fetchSeminarsNearMe(
          {
            limit: 25,
            seminarType:
              seminarType === 'all' ? SEMINARS_ALL_QUERY : seminarType,
          },
          token,
        )

        setSeminars(
          results
            .filter((seminar) => seminar.isAvailable)
            .sort(sortByDates)
            .slice(0, limit),
        )
      } catch (error) {
        errorLogging(new Error('error fetching seminars near me'), {
          error,
        })
      } finally {
        setIsLoading(false)
      }
    }

    fetch()
  }, [seminarType])

  return {
    isLoading,
    seminars,
  }
}

export default useSeminars
